<template >
  <Modal ref="modal">
    <div id="alertModal" class="modal-wrap active" style="z-index: 1001;">
      <div class="modal-inner">
        <div class="modal-content modal-xs" tabindex="-1">
          <div class="modal-header">
            <h2 class="modal-title">{{title}}</h2>
            <button type="button" class="btn-modal-close" @click="cancel">
              <img src="@/assets/img/ico/i-colse.svg" alt="닫기" />
            </button>
          </div>
          <div class="modal-body">
            <div class="modal-body-info sm" v-html="content"></div>
          </div>
          <div class="modal-footer">
            <div class="btn-group btn-space-xxs">
              <button
                type="button"
                class="btn btn-md btn-tertiary btn-modal-close"
                @click="cancel"
              >{{cancelButtonText}}</button>
              <button
                type="button"
                class="btn btn-md btn-primary"
                @click="confirm"
              >{{confirmButtonText}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from "@/components/base/Modal.vue";
export default {
  components: {
    Modal,
  },
  data() {
    return {
      title: "확인",
      content: "확인해 주세요.",
      confirmButtonText: "확인",
      cancelButtonText: "취소",
      resolvePromise: undefined,
    };
  },
  methods: {
    show(content) {
      this.setContent(content);
      this.$refs.modal.open();

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
      });
    },
    confirm() {
      this.$refs.modal.close();
      this.resolvePromise(true);
    },
    cancel() {
      this.$refs.modal.close();
      this.resolvePromise(false);
    },
    setContent(content) {
      if (content == undefined) {
        return;
      }

      this.title = content.title ? content.title : this.title;
      this.content = content.content ? content.content : this.content;
      this.confirmButtonText = content.confirmButtonText
        ? content.confirmButtonText
        : this.confirmButtonText;
      this.cancelButtonText = content.cancelButtonText
        ? content.cancelButtonText
        : this.cancelButtonText;
    },
  },
};
</script>